<empty-layout *ngIf="layout === 'empty'"></empty-layout>

<manager-layout *ngIf="layout === 'manager'"></manager-layout>
<store-layout *ngIf="layout === 'store'"></store-layout>